import { FETCH_ALL_EVENT_MAPS, SET_MAP_DETAILS } from '../actions';

export const eventMaps = (state = {}, action) => {
  if (action.type == FETCH_ALL_EVENT_MAPS) {
    return action.payload;
  }
  return state;
};

export const eventMapDetails = (state = {}, action) => {
  if (action.type == SET_MAP_DETAILS) {
    return action.payload;
  }
  return state;
};
